import { h,  render } from 'preact'; // eslint-disable-line no-unused-vars
import { EstateCard, EstateEmptyState } from './cards/Estate';

export function renderEstateCards(wrapper, estates) {
    document.getElementById(wrapper).innerHTML = '';
    var productCount = 0;

    // sort estates alphabetically but grouped Now selling, Comming soon, then completed at the end
    estates.sort((a, b) => {
        var nameA = a.name.toLowerCase(); // ignore upper and lowercase
        var nameB = b.name.toLowerCase(); // ignore upper and lowercase

        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }      
        // names must be equal
        return 0;     
    });

    estates.sort((a, b) => {
        // if there is a null project status it will throw a typeerror as it can't tolowercase a null value
        try {
            var statusA = a.projectStatus.toLowerCase();
            var statusB = b.projectStatus.toLowerCase();
            
            if (statusA === statusB) {
                return 0;
            }
            if (statusA === "coming") {
                return 1;
            }
            if (statusB === "coming") {
                return -1;
            }
        }
        catch (err) {
            return 0;
        }
    });

    estates.sort((a, b) => {
        // if there is a null project status it will throw a typeerror as it can't tolowercase a null value
        try {
            var statusA = a.projectStatus.toLowerCase();
            var statusB = b.projectStatus.toLowerCase();
            // i want the item with sold to be moved down but what if they're both sold? nothing? ok.
            if (statusA === statusB) {
                return 0;
            }
            if (statusA === "sold") {
                return 1;
            }
            if (statusB === "sold") {
                return -1;
            }
        }
        catch (err){
            return 0;
        }
    });

    estates.forEach(estate => {
        if (estate.lat && estate.lng) { // To prevent Peet Complete estates from appearing
            const estateCard = <EstateCard { ...estate } />
            render(estateCard, document.getElementById(wrapper));
            productCount++;
        }        
    });

    if (productCount == 0) {
        const estateEmptyState = <EstateEmptyState />;
        render(estateEmptyState, document.getElementById(wrapper));
    }

}
